import cn from 'classnames';
import type React from 'react';
import { useCoachQuery } from '@src/api/api-hooks/coaches/useCoachQuery.ts';
import * as st from './styles.module.scss';

interface Props {
  id: number;
  isIndividualCoachCard?: boolean;
}

export const Tags: React.FC<Props> = ({ id, isIndividualCoachCard = false }) => {
  const { data: coach } = useCoachQuery({ id: String(id) });

  return <span className={cn(st.tags)}>{coach?.tags.map((tag) => tag.title).join(', ')}</span>;
};
